__webpack_require__.p = "/innovation/api/ccp/v1/quizzes/vba/haircare/";